export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // Navigation toggle
    $('.nav-toggle').click(function() {
      if (!$('.navigation').hasClass('active')) {
        $('.navigation').addClass('active');
        $('html,body').addClass('overlay');
        $('<div />').attr('id', 'overlay').prependTo('body');
        $('#overlay').click(function() {
          $('.navigation').removeClass('active');
          $('html,body').removeClass('overlay');
          $(this).remove();
        });
      } else {
        $('.navigation').removeClass('active');
        $('html,body').removeClass('overlay');
        $('#overlay').remove();
      }
    });

    $('.menu-item-has-children > a').click(function(e) {
      if ($(e.target).is('svg') || $(e.target).is('path')) {
        e.preventDefault();
        var menu = $(this).closest('li');

        if (menu.hasClass('is-open')) {
          menu.removeClass('is-open');
          menu.find('a > svg').replaceWith('<i class="fas fa-caret-down"></i>');
        } else {
          menu.addClass('is-open');
          menu.find('a > svg').replaceWith('<i class="fas fa-caret-up"></i>');
        }
      }
    });

    $('.navigation.mobile .current-menu-item.menu-item-has-children').addClass('is-open');
    $('.navigation.mobile .current-menu-ancestor').addClass('is-open');


    $('.navigation.mobile .menu-item-151').prepend('<i class="fas fa-home"></i>');
    $('.navigation.mobile .menu-item-1713').prepend('<i class="fas fa-money-bill-alt"></i>');
    $('.navigation.mobile .menu-item-1714').prepend('<i class="fas fa-arrow-alt-circle-up"></i>');
    $('.navigation.mobile .menu-item-42').prepend('<i class="fas fa-handshake"></i>');
    $('.navigation.mobile .menu-item-46').prepend('<i class="fas fa-question-circle"></i>');
    $('.navigation.mobile .menu-item-38').prepend('<i class="fas fa-user-circle"></i>');
    $('.navigation.mobile .menu-item-47').prepend('<i class="fas fa-building"></i>');
    $('.navigation.mobile .menu-item-has-children:not(.is-open) > a').append('<i class="fas fa-caret-down"></i>');
    $('.navigation.mobile .menu-item-has-children.is-open > a').append('<i class="fas fa-caret-up"></i>');
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js